import { useDefaultLayoutState } from '@/app/store';
import { Flex, Icon } from '@chakra-ui/react';
import {
  AiOutlineDoubleLeft,
  AiOutlineDoubleRight,
} from 'react-icons/ai/index.js';

export interface SideBarProps {
  children: React.ReactNode;
}

export const SideBar = (props: SideBarProps) => {
  const { children } = props;
  const { isSiderCollapsed, toggleSider } = useDefaultLayoutState();
  return (
    <Flex
      w={isSiderCollapsed ? 20 : 56}
      boxShadow='0 2px 8px 0 rgb(99 99 99 / 20%)'
      flexDir='column'
    >
      {children}
      <Flex
        position='sticky'
        bottom={0}
        left={0}
        p={4}
        cursor='pointer'
        boxShadow='md'
        onClick={() => toggleSider(!isSiderCollapsed)}
      >
        <Icon
          as={isSiderCollapsed ? AiOutlineDoubleRight : AiOutlineDoubleLeft}
          mx='auto'
          color='primary'
          fontSize='sm'
        />
      </Flex>
    </Flex>
  );
};
